import React from 'react';
import strings from "../../../localization";
import {getError, hasError} from "../../../functions/Validation";
import {Button, TextField, Divider, Chip} from "@material-ui/core";
import SelectControl from '../../controls/SelectControl';
import Grid from '@material-ui/core/Grid';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloseIcon from "@material-ui/icons/Close";
import DocumentType from "../../../constants/DocumentType";
import ApplicationInternalStatus from '../../../constants/ApplicationInternalStatus';
import { checkPermission } from '../../../util/SecurityUtil';
import Permission from '../../../constants/Permission';

const MedicalDeclarationForm = ({
                            onSubmit,
                            onCancel,
                            onChange,
                            errors,
                            data,
                            onDelete,
                            titles,
                            genders,
                            disabled,
                            handleToggle,
                            user,
                            rehabilitationRef
                        }) => (

    <form id='medical-declaration-form'>
        <Grid container spacing={9} className={'grid-wrapper'}>
            {
                checkPermission(user.userType, Permission.MEDICAL_DECLARATION_VIEW) &&
                <React.Fragment>
                    <Grid item md={10}>
                        <div className={'question'}>{ strings.medicalDeclaration.medicalDeclarationQuestion }</div>
                    </Grid>
                    <Grid item md={9} className={'switch-wrapper'}>
                        <label className="switch" onClick={handleToggle}>
                            <input checked={data.haveMedicalConditions} disabled={ disabled } type="checkbox" id="togBtn" name={'haveMedicalConditions'}/>
                            <div className="slider round">
                                <span className="on">YES</span>
                                <span className="off">NO</span>
                            </div>
                        </label>
                    </Grid>

                    {
                        data.haveMedicalConditions
                            ?
                            <div className={'medical-declaration-show'}>
                                <Grid item md={9}>
                                    <div className={'medical-declaration-comment'}>
                                        <label>{ strings.medicalDeclaration.medicalDeclarationYes }</label>
                                        <TextField
                                            placeholder={strings.medicalDeclaration.enterText}
                                            multiline
                                            rows={2}
                                            rowsMax={4}
                                            variant={'outlined'}
                                            onChange={onChange}
                                            name={'medicalConditionDescription'}
                                            value={ data ? data.medicalConditionDescription : '' }
                                            disabled={ disabled }
                                        />
                                    </div>
                                </Grid>
                            </div>
                            :
                            ""
                    }
                </React.Fragment>
            }

            {
                !checkPermission(user.userType, Permission.MEDICAL_DECLARATION_VIEW) &&
                <Grid item md={10}>
                    <div className={'question'}>{ strings.medicalDeclaration.medicalDeclarationNotAllowed }</div>
                </Grid>
            }
                 
        </Grid>
        <Divider />

        <h1>{strings.medicalDeclaration.rehabilitation}</h1>
        <Grid container spacing={9} className={'grid-wrapper'} ref={rehabilitationRef} id="rehabilitation">

            {
                checkPermission(user.userType, Permission.REHABILITATION) &&
                <React.Fragment>
                    <Grid item md={10}>
                        <div className={'question'}>{ strings.medicalDeclaration.rehabilitationQuestion }</div>
                    </Grid>
                    <Grid item md={9} className={'switch-wrapper'}>
                        <label className="switch" onClick={handleToggle}>
                            <input checked={data.rehabilitationOfOffenders} disabled={ disabled } type="checkbox" id="togBtn" name={'rehabilitationOfOffenders'}/>
                            <div className="slider round">
                                <span className="on">YES</span>
                                <span className="off">NO</span>
                            </div>
                        </label>
                    </Grid>
                    {
                        data.rehabilitationOfOffenders
                            ?
                            <div className={'medical-declaration-show'}>
                                <Grid item md={9}>
                                    <div className={'medical-declaration-comment'}>
                                        <label>{ strings.medicalDeclaration.rehabilitationYes }</label>
                                        <TextField
                                            placeholder={strings.medicalDeclaration.enterText}
                                            multiline
                                            rows={2}
                                            rowsMax={4}
                                            variant={'outlined'}
                                            onChange={onChange}
                                            name={'rehabilitationComment'}
                                            value={ data ? data.rehabilitationComment : '' }
                                            disabled={ disabled }
                                        />
                                    </div>
                                </Grid>
                            </div>
                            :
                            ""
                    }
                </React.Fragment>
            }
            {
                !checkPermission(user.userType, Permission.REHABILITATION) &&
                <Grid item md={10}>
                    <div className={'question'}>{ strings.medicalDeclaration.rehabilitationNotAllowed }</div>
                </Grid>
            }
        </Grid>
        <Divider />
        
        {/* Mandatory Ethical Recruitment Declaration */}
        <h1>Mandatory Ethical Recruitment Declaration</h1>
        <Grid container spacing={9} className={'grid-wrapper'}>
            <Grid item md={10}>
                <div className={'question'}>
                    Have you paid any fees, costs, or charges (directly or indirectly) to any individual, agent, or organisation in order to obtain this role?
                </div>
            </Grid>
            <Grid item md={9} className={'switch-wrapper'}>
                <label className="switch" onClick={!disabled ? handleToggle : undefined}>
                    <input
                        checked={!!data.ethicalRecruitmentFeesPaid}
                        disabled={disabled}
                        type="checkbox"
                        id="ethicalRecruitmentFeesPaid"
                        name={'ethicalRecruitmentFeesPaid'}
                    />
                    <div className="slider round">
                        <span className="on">YES</span>
                        <span className="off">NO</span>
                    </div>
                </label>
            </Grid>
        </Grid>
        {
            !!data.ethicalRecruitmentFeesPaid
                ?
                <div id="ethical-recruitment-follow-up-form">
                    <Grid container spacing={9} className={'grid-wrapper'}>
                        <Grid item md={10}>
                            <div className={'question'}>
                                You recently indicated that you had been asked to pay a fee, cost or charge for your recruitment.
                                This is of great concern to us and we would like to ask you to provide more information please:
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={9} className={'grid-wrapper'}>
                        <Grid item xl={4} lg={5} md={12}>
                            <div className={'select-container' + (hasError(errors, 'ethicalRecruitmentPaymentRequestedBy') ? ' error' : '')}>
                                <label>Who requested this payment?</label>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={hasError(errors, 'ethicalRecruitmentPaymentRequestedBy')}
                                    helperText={getError(errors, 'ethicalRecruitmentPaymentRequestedBy')}
                                    fullWidth
                                    name={'ethicalRecruitmentPaymentRequestedBy'}
                                    onChange={onChange}
                                    value={data ? data.ethicalRecruitmentPaymentRequestedBy || '' : ''}
                                    margin="dense"
                                    variant={'outlined'}
                                    disabled={disabled}
                                />
                            </div>

                            <div className={'select-container' + (hasError(errors, 'ethicalRecruitmentAmountRequested') ? ' error' : '')}>
                                <label>How much did they request?</label>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    type="number"
                                    inputProps={{ min: 0, step: '0.01' }}
                                    error={hasError(errors, 'ethicalRecruitmentAmountRequested')}
                                    helperText={getError(errors, 'ethicalRecruitmentAmountRequested')}
                                    fullWidth
                                    name={'ethicalRecruitmentAmountRequested'}
                                    onChange={onChange}
                                    value={data && data.ethicalRecruitmentAmountRequested !== null && data.ethicalRecruitmentAmountRequested !== undefined ? data.ethicalRecruitmentAmountRequested : ''}
                                    margin="dense"
                                    variant={'outlined'}
                                    disabled={disabled}
                                />
                            </div>

                            <div className={'select-container' + (hasError(errors, 'ethicalRecruitmentFeeWasPaid') ? ' error' : '')}>
                                <label>Did you pay it?</label>
                                <div className={'switch-wrapper'}>
                                    <label className="switch" onClick={!disabled ? handleToggle : undefined}>
                                        <input
                                            checked={!!data.ethicalRecruitmentFeeWasPaid}
                                            disabled={disabled}
                                            type="checkbox"
                                            id="ethicalRecruitmentFeeWasPaid"
                                            name={'ethicalRecruitmentFeeWasPaid'}
                                        />
                                        <div className="slider round">
                                            <span className="on">YES</span>
                                            <span className="off">NO</span>
                                        </div>
                                    </label>
                                </div>
                                {
                                    hasError(errors, 'ethicalRecruitmentFeeWasPaid') &&
                                    <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: '4px' }}>
                                        {getError(errors, 'ethicalRecruitmentFeeWasPaid')}
                                    </div>
                                }
                            </div>

                            <div className={'select-container' + (hasError(errors, 'ethicalRecruitmentPaymentExplanation') ? ' error' : '')}>
                                <label>What explanation was given as to why a payment was due?</label>
                                <TextField
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={hasError(errors, 'ethicalRecruitmentPaymentExplanation')}
                                    helperText={getError(errors, 'ethicalRecruitmentPaymentExplanation')}
                                    fullWidth
                                    name={'ethicalRecruitmentPaymentExplanation'}
                                    onChange={onChange}
                                    value={data ? data.ethicalRecruitmentPaymentExplanation || '' : ''}
                                    margin="dense"
                                    variant={'outlined'}
                                    multiline
                                    rows={2}
                                    rowsMax={4}
                                    disabled={disabled}
                                />
                            </div>
                        </Grid>

                        <Grid item xl={4} lg={5} md={12}>
                        </Grid>
                    </Grid>
                </div>
                :
                null
        }
        <Divider />
    </form>
);

export default MedicalDeclarationForm;